import styled from "styled-components";

import { media } from "../../../../styles/media";

export const BranchFormStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .input {
    margin-top: 2px;
  }

  .fieldRow {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[24]};

    > * {
      flex: 1;
    }

    &.threeCol > * {
      flex: 1;
    }

    /* Stack the multi-column rows (e.g. State / City / ZIP) on phones so the
       inputs aren't crushed. */
    ${media.maxMobile`
      flex-direction: column;
      gap: 16px;
    `}
  }

  .fieldGroup {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
  }

  .sectionDivider {
    height: 1px;
    background-color: ${({ theme }) => theme.colors.semantic.separator};
    margin: ${({ theme }) => theme.spacing[8]} 0;
  }

  .cardHeaderRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  .sectionSaveBtn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    animation: fadeSlideIn 0.25s ease-out;
  }
`;
